<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <!--
        <sidebar-link to="/dashboard" :name="$t('sidebar.dashboard')" icon="tim-icons icon-chart-pie-36"/>
        <sidebar-link to="/icons" :name="$t('sidebar.icons')" icon="tim-icons icon-atom"/>
        <sidebar-link to="/maps" :name="$t('sidebar.maps')" icon="tim-icons icon-pin"/>
        <sidebar-link to="/notifications" :name="$t('sidebar.notifications')" icon="tim-icons icon-bell-55"/>
        <sidebar-link to="/profile" :name="$t('sidebar.userProfile')" icon="tim-icons icon-single-02"/>
        <sidebar-link to="/table-list" :name="$t('sidebar.tableList')" icon="tim-icons icon-puzzle-10"/>
        <sidebar-link to="/typography" :name="$t('sidebar.typography')" icon="tim-icons icon-align-center"/>
        <sidebar-link to="/dashboard?enableRTL=true" :name="$t('sidebar.rtlSupport')" icon="tim-icons icon-world"/>
        -->
        <sidebar-link to="/roster" :name="$t('sidebar.roster')" icon="tim-icons icon-room"/>
        <sidebar-link to="/rooms" :name="$t('sidebar.rooms')" icon="tim-icons icon-room"/>
        <sidebar-link to="/shifts" :name="$t('sidebar.shifts')" icon="tim-icons icon-shift"/>
        <sidebar-link to="/files" :name="$t('sidebar.files')" icon="tim-icons icon-file"/>
        <sidebar-link to="/payroll" :name="$t('sidebar.payroll')" icon="tim-icons icon-money"/>
        <sidebar-link to="/positions" :name="$t('sidebar.positions')" icon="tim-icons icon-money"/>
        <sidebar-link to="/locations" :name="$t('sidebar.locations')" icon="tim-icons icon-money"/>
        <sidebar-link to="/users" :name="$t('sidebar.users')" icon="tim-icons icon-money"/>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
